import React, { useMemo, useState, forwardRef, useRef } from "react";
import { Button as BootstrapButton, ButtonGroup as BootstrapButtonGroup,  Overlay, Popover } from "react-bootstrap";
import {
  Box,
  Sheet,
  Table,
  Typography,
  Select,
  Option,
  ButtonGroup,
  Button,
  IconButton
} from '@mui/joy';
import { Lock, Trash2, Unlock } from "react-feather";
import { useControl, useControlReducer } from "../../../controlContext";
import { useControlHeaderContext } from "../../../controlWrapperContext";
import { TOP_BLOCK } from "../../../../../shared/Data/typeDirs";

export function ReportBlockUtilities({ idx, name }) {
  const { [idx]: file } = useControl()
  const { _id, type } = file
  const controlReducer = useControlReducer()
  const { settings: { lockMap, lockedBlock, allReadOnly, printPreview } } = useControlHeaderContext()
  const [clickedAction, setClickedAction] = useState({})
  const readOnly = useMemo(()=>(allReadOnly ? true : lockMap && lockMap[file._id]), [lockMap, allReadOnly, file._id])
  const lockBtnRef = useRef();
  // console.log('ReportBlockUtilities | render readOnly', readOnly)
  return printPreview ? [] : (
    <div className="controls">
      <BootstrapButtonGroup
      title={lockedBlock !== _id ? 'Lock the block before removing' : ''}>     
        <LockButton 
          ref={lockBtnRef}
          locked={readOnly || lockedBlock === file._id}
          onClick={(locked) =>
            setClickedAction({
              target: lockBtnRef.current,
              type: locked ? 'unlock' : 'lock',
              callback: () => controlReducer({ type: locked ? 'unlock' : 'lock', file: { _id }, idx, name })
            })
          }
        />
        {type !== TOP_BLOCK && (
          <BootstrapButton 
            disabled={lockMap && lockMap[_id] && lockedBlock !== _id} 
            variant={`${lockMap && lockMap[_id] && lockedBlock !== _id ? 'secondary' : 'danger' }`}
            className="btn btn-sm"
            onClick={({ target }) => setClickedAction({ target, type: 'delete', callback: () => controlReducer({ type: 'delete_block', file, idx, name }) })}>
            <Trash2  width={22} />
          </BootstrapButton>
        )}
      </BootstrapButtonGroup>
      {<Overlay target={clickedAction.target} show={!!clickedAction.target} placement="left-start" onHide={() => setClickedAction({})} rootClose>
      <Popover>
        <Popover.Header>Confirm {clickedAction.type && clickedAction.type.toUpperCase()}</Popover.Header>
        <Popover.Body>
          <div style={{marginBottom: '15px'}}>
            Are you sure you would like to {clickedAction.type && clickedAction.type.toUpperCase()} this block?
          </div>
          <div>
          <Button variant="outlined" onClick={() => {
            document.body.click()
          }} 
          color="neutral"
          style={{marginRight: '15px'}}>
            Cancel
          </Button>
         
          <Button variant="outlined"  color="danger" onClick={() => {
            document.body.click()
            setTimeout(()=>clickedAction.callback())
          }}>
            Confirm
          </Button>
          </div>
        </Popover.Body>
      </Popover>
    </Overlay>}
    </div>
  )
}
export const LockButton = forwardRef(function LockButton({ locked, onClick }, ref) {
  const [mouseover, setMouseover] = useState(false)
  const Icon = useMemo(() => {
    return mouseover ? locked ? Unlock : Lock : locked ? Lock : Unlock
  }, [locked, mouseover])
  // console.log('LockButton | render locked', locked)
  return (
    <BootstrapButton className="btn btn-sm "

      ref={ref}
      variant={!mouseover ? 'info' : 'danger'}
      onMouseEnter={() => setMouseover(true)}
      onMouseLeave={() => setMouseover(false)}
      onClick={() => onClick(locked)}
    >
      <Icon width={20} />
      </BootstrapButton>
  )
})

function UtilitiesOverlay({ clickedAction, ...rest }) {
  return (
    <Popover {...rest}>
      <Popover.Header>Confirm {clickedAction.type}</Popover.Header>
      <Popover.Body>
        <div>
          Are you sure you would like to {clickedAction.type} this block?
        </div>
      </Popover.Body>
      <Popover.Header>
        <Button variant="outline-secondary" onClick={document.body.click}>
          Cancel
        </Button>
        <Button variant="outline-activated" onClick={clickedAction.callback}>
          Confirm
        </Button>
      </Popover.Header>
    </Popover>
  )
}
